import axios from 'axios';
import Cookies from 'js-cookie';

import {
  publicAxiosHeader,
  axiosHeader,
  getV1RootUrl
} from 'common/helpers/apiHelper';

export const contactUsForm = (form) =>
  axios.post(`${getV1RootUrl()}/form/contact-us`, form, publicAxiosHeader());

export const subscribeForm = (form) =>
  axios.post(`${getV1RootUrl()}/customer/subscribe`, form, publicAxiosHeader());

export const feedbackForm = (form) =>
  axios.post(`${getV1RootUrl()}/form/feedback`, form, publicAxiosHeader());

export const contactForm = (form) =>
  axios.post(`${getV1RootUrl()}/form/contact`, form, publicAxiosHeader());

export const getForm = (code) =>
  axios.get(`${getV1RootUrl()}/form/code/${code}/for-web`, publicAxiosHeader());

export const submitForm = (response, formId) => {
  if (Cookies.get('customerToken')) {
    return axios.post(
      `${getV1RootUrl()}/form/${formId}/response`,
      response,
      axiosHeader()
    );
  }
  return axios.post(
    `${getV1RootUrl()}/form/${formId}/response`,
    response,
    publicAxiosHeader()
  );
};
